import { extendObservable } from 'mobx';

class CampaignSearchStore {
  constructor() {
    extendObservable(this, {
      searchTerm: '',
      results: [],
      isLoading: false,
      isVisible: false,
      searchInput: null,
    });
  }

  replaceResults = (newResults) => {
    this.results.replace(newResults);
    this.isLoading = false;
  };

  resetSearch = () => {
    this.searchTerm = '';
    this.results.clear();
    this.isLoading = false;
    this.location = null;
  };

  clearResults = () => {
    this.results.clear();
  };

  startSearch = () => {
    this.isVisible = true;
  };

  stopSearch = () => {
    this.isVisible = false;
  };
}

export default new CampaignSearchStore();
